import type { ExploreScopeSelection } from "@/analytics/core/types";

export type RawScopeFilterKind = "none" | "team" | "team-rep";

/** `single-team` matches Explore (reps apply only with one team). `always` shows rep filter anytime. */
export type RawRepPickerMode = "single-team" | "always";

export function filterRowsByScope<T extends Record<string, unknown>>(
  rows: T[],
  kind: RawScopeFilterKind,
  selection: ExploreScopeSelection,
  repPicker: RawRepPickerMode = "single-team",
): T[] {
  if (kind === "none") return rows;

  const { teamIds, repIds } = selection;

  if (kind === "team") {
    if (teamIds.length === 0) return rows;
    return rows.filter((row) => {
      const teamId = (row.team_id ?? row.id) as number | undefined;
      return teamId != null && teamIds.includes(teamId);
    });
  }

  let filtered = rows;
  if (teamIds.length > 0) {
    filtered = filtered.filter((row) => {
      const teamId = row.team_id as number | undefined;
      return teamId != null && teamIds.includes(teamId);
    });
  }

  const applyRepFilter = repIds.length > 0 && (repPicker === "always" || teamIds.length === 1);

  if (applyRepFilter) {
    filtered = filtered.filter((row) => {
      const repId = (row.rep_id ?? row.id) as number | undefined;
      return repId != null && repIds.includes(repId);
    });
  }

  return filtered;
}
